var wrappedFunctions = require('./viewerScript').wrappedFunctions; //tslint:disable-line

module.exports = {
  initAppForPage: wrappedFunctions.initAppForPage,
  createControllers: wrappedFunctions.createControllers,
  exports: {}
};
